/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { PersonGbMasterId } from './personGbMasterId';
import { PersonGbVersionId } from './personGbVersionId';
import { DateEntryMeta } from './dateEntryMeta';


export interface PersonGbListEntryMeta { 
    ledigname?: string;
    mLedigname?: FieldMetaData;
    id: PersonGbMasterId;
    mId?: FieldMetaData;
    versionId: PersonGbVersionId;
    mVersionId?: FieldMetaData;
    geburtsdatum?: DateEntryMeta;
    mGeburtsdatum?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    unternehmensId?: string;
    mUnternehmensId?: FieldMetaData;
    auskunftsperre?: PersonGbListEntryMeta.AuskunftsperreEnum;
    mAuskunftsperre?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    sitz?: string;
    mSitz?: FieldMetaData;
}
export namespace PersonGbListEntryMeta {
    export type AuskunftsperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const AuskunftsperreEnum = {
        AUSKUNFT_SPERRE: 'AUSKUNFT_SPERRE' as AuskunftsperreEnum,
        ADRESS_SPERRE: 'ADRESS_SPERRE' as AuskunftsperreEnum,
        KEINE: 'KEINE' as AuskunftsperreEnum
    };
}


